module.exports = __webpack_public_path__ + "0ab96fdfe4e80b29767ffdf7c7e939fd.svg";